import core from "@gtmhub/core/module";

import { ExecuteInsightCtrl } from "./execute-insight/execute-insight.ctrl";
import { EditFiltersCtrl } from "./edit-filters/edit-filters.ctrl";
import { BrowseConnectionsCtrl } from "./browse-connections/browse-connections.ctrl";
import { BrowseInsightsCtrl } from "./browse-insights/browse-insights.ctrl";
import { BuildInsightCtrl } from "./build-insight/build-insight.ctrl";
import { InsightSelector } from "./insight-selector";
import { InsightSelectorCtrl } from "./insight-selector.ctrl";
import { InsightSelectorService } from "./insight-selector-service";
import { DatasourceListItemComponent } from "./datasource-list-item/datasource-list-item.component";
import { SelectEntityFromListButtonComponent } from "./select-entity-from-list-button/select-entity-from-list-button.component";

export default angular
  .module("insightSelector", [core])
  .controller("ExecuteInsightCtrl", ExecuteInsightCtrl)
  .controller("EditFiltersCtrl", EditFiltersCtrl)
  .controller("BrowseConnectionsCtrl", BrowseConnectionsCtrl)
  .controller("BrowseInsightsCtrl", BrowseInsightsCtrl)
  .controller("BuildInsightCtrl", BuildInsightCtrl)
  .controller("InsightSelectorCtrl", InsightSelectorCtrl)
  .service("InsightSelectorService", InsightSelectorService)
  .directive("insightSelector", InsightSelector.factory())
  .component("datasourceListItem", DatasourceListItemComponent)
  .component("selectEntityFromListButton", SelectEntityFromListButtonComponent).name;
